import styled from 'styled-components';

export const ImagesSliderContainer = styled.div`
  display: flex;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  cursor: grab;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  scroll-behavior: smooth;
  margin: 24px 0;
  padding-bottom: 16px;

  &::-webkit-scrollbar {
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    margin-top: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #aeaeb2;
    border-radius: 46px;
  }

  @media (prefers-color-scheme: dark) {
    &::-webkit-scrollbar-thumb {
      background-color: #8e8e93;
      border-radius: 46px;
    }
  }

  &:active {
    cursor: grabbing;
  }
`;

export const SliderImage = styled.img`
  width: 161px;
  height: 349px;
  object-fit: cover;
  flex-shrink: 0;
  scroll-snap-align: start;
  border-radius: 18px;

  &:not(:last-child) {
    margin-inline-end: ${({ $gap }) => $gap}px;
  }
`;
